import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail, BRAND } from "@/lib/api";
import { MailCheck } from "lucide-react";

const Card = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] px-5">
    <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-xl">
      <div className="text-center mb-8">
        <div className="h-16 w-16 gh-octagon bg-black mx-auto flex items-center justify-center overflow-hidden ring-1 ring-[#D9CBA0]/50 mb-4">
          <img src={BRAND.logo} alt="Hope & Favor" className="h-full w-full object-contain" />
        </div>
        <h1 className="font-heading text-3xl text-[#3A3632]">Hope &amp; Favor</h1>
        <p className="text-sm text-[#8A8175] mt-1">Reset your password</p>
      </div>
      {children}
    </div>
  </div>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong. Please try again.");
    } finally { setBusy(false); }
  };

  if (sent) return (
    <Card>
      <div className="text-center" data-testid="forgot-sent">
        <div className="h-12 w-12 rounded-full bg-[#8E9A86]/12 mx-auto flex items-center justify-center mb-4"><MailCheck className="h-6 w-6 text-[#8E9A86]" /></div>
        <p className="text-[#3A3632] leading-relaxed">If an account exists for <strong className="break-all">{email}</strong>, a password reset link is on its way. It expires in 1 hour.</p>
        <p className="text-sm text-[#8A8175] mt-3">Be sure to check your spam folder.</p>
        <Link to="/login" className="block text-sm text-[#8E9A86] mt-6 hover:underline">← Back to sign in</Link>
      </div>
    </Card>
  );

  return (
    <Card>
      <form onSubmit={submit} data-testid="forgot-form" className="space-y-4">
        <p className="text-sm text-[#6B655F] leading-relaxed">Enter your admin email and we'll send you a secure link to reset your password.</p>
        <input type="email" name="email" autoComplete="username" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="w-full border border-[#D1CCC5] rounded-lg px-4 py-3 outline-none focus:border-[#8E9A86] focus:ring-2 focus:ring-[#8E9A86]/30" />
        {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full bg-[#8E9A86] text-white rounded-full py-3 font-medium hover:bg-[#7A8772] transition-colors disabled:opacity-60">{busy ? "Sending…" : "Send reset link"}</button>
      </form>
      <Link to="/login" className="block text-center text-sm text-[#8A8175] mt-5 hover:text-[#8E9A86]">← Back to sign in</Link>
    </Card>
  );
}
